(() => {
  for (const root of document.querySelectorAll('.contact-form--sur-mesure')) {
    const data = root.querySelector('.snk-upload-translations');
    if (!data) continue;
    const translations = JSON.parse(data.textContent);
    const localize = () => {
      const upload = root.querySelector('.upload-lift');
      if (!upload) return;
      for (const option of upload.querySelectorAll('option')) {
        if (!option.hasAttribute('value')) option.setAttribute('value', option.value);
      }
      const walker = document.createTreeWalker(upload, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.parentElement?.closest('script, style, textarea')) continue;
        const source = node.nodeValue.trim();
        const target = translations[source];
        if (typeof target === 'string' && target !== source) {
          node.nodeValue = node.nodeValue.replace(source, target);
        }
      }
      for (const element of upload.querySelectorAll('[placeholder], [aria-label], [title]')) {
        for (const attribute of ['placeholder', 'aria-label', 'title']) {
          const source = element.getAttribute(attribute);
          if (source && typeof translations[source] === 'string' && translations[source] !== source) {
            element.setAttribute(attribute, translations[source]);
          }
        }
      }
    };
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        localize();
      });
    });
    observer.observe(root, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['placeholder', 'aria-label', 'title']});
    localize();
  }
})();
